import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";


export const addPatientInsurance = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Patient Insurance Coverage',
    body
  );
  return data;
});
export const updatePatientInsurance = catchAsync(async ({body,id}) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Patient Insurance Coverage/${id}`,
    body
  );
  return data;
});
export const deletePatientInsurance = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Patient Insurance Coverage/${id}`
  );
  return data;
});

export const getPatientInsuranceCoverage = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Patient Insurance Coverage?fields=["name","mode_of_approval","item_code","insurance_plan","insurance_payor","patient_name","status"]'
  );
  return data;
});
export const getPatientInsuranceCoverageById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Patient Insurance Coverage/${id}`
  );
  return data;
});